<template>
    <div class="ads">
        <List v-if="client_id" :DB="list" :client_id="client_id" @emit="emit"/>
        <statsAds v-if="ad" :ad="ad" @emit="emit" />
        <div v-if="voucher" class="voucher fixed-scroller">
            <div class="v-alert">
                <header><p>Offer</p><div class="x" @click="voucher = false"></div></header>
                <Voucher :voucher="voucher" :nobtns="true" />
            </div>
        </div>
        <component v-if="component" :is="component" :item="item" @emit="emit" />
    </div>
</template>

<script>

import { mapMutations } from 'vuex'
import List from '../components/List.vue'
import { format } from 'date-fns';
import prettyPhone from '../utils/prettyPhone.js'
import Voucher from '../components/Voucher.vue';
import WebSoc from '../utils/WebSoc.js';
import statsAds from '../components/statsAds.vue'
import Alert from '../utils/Alert.js'
import statsCustomerCampaign from '../components/statsCustomerCampaign'
export default {
    name: 'ads',
    components: {
        List,
        Voucher,
        statsAds,
        statsCustomerCampaign
    },
    computed: {
        client_id () { return this.$store.state.client_id },
        db () { return this.$store.state.client_id+'-customers' }
    },
    created () {
        this.list.db = this.db;
    },
    mounted () {
        this.list.filter.client_id = this.client_id;
    },
    data () {
        return {
            voucher: false,
            item: false,
            component: '',
            ad: false,
            list: { 
                t: 'ad-list',
                DB: 'jb-ads',
                dbClient_id: '',
                storeDB: true,
                title: 'Offers',
                db: '',
                fields: [
                    { title: 'Offer', field: 'title', class: 'td-ulb', width: 300, map: item => item.title || 'no title' },
                    { title: 'Created', field: 'created', class: 'ta-r', width: 200, map: item => item.created > 0 ? format(item.created,'dd/MM/yy HH:mm') : '', type: 'date' },
                    { title: 'Sent', field: 'qtySent', width: 110, class: 'ta-r td-ulb' },
                    { title: 'Members', field: 'customers', width: 120, class: 'ta-r td-ulb', map: item => (item.customers || []).length },
                    { title: 'Campaigns', field: 'campaigns', width: 120, class: 'ta-r td-ulb', map: item => (item.campaigns || []).length },
                    { title: 'Tot. Spins', field: 'rotate', class: 'ta-r td-ulb', width: 115 },
                    { title: 'Ind. Spins', field: 'dRotate', class: 'ta-r td-ulb', width: 115, map: item => Object.keys(item.dRotate || {}).length },
                    { title: 'Redeems', field: 'redeemCount', class: 'ta-r td-ulb', width: 115 },
                    { title: 'Tot Ext Lnk', field: 'dLinked', class: 'ta-r  td-ulb', width: 115, map: item => (item.dLinked || []).length },
                    { title: 'Ind Ext Lnk', field: 'dLink', class: 'ta-r td-ulb', width: 115, map: item => Object.keys(item.dLink || {}).length },
                    { title: 'Redeem Date', field: 'redeemRewards', class: 'ta-r', width: 300, map: item => { 
                        var rr = item.redeemRewards;
                        if ( !rr ) return ''; 
                        var first = rr[0]; 
                        var last = rr[rr.length-1]; 
                        first = first > 0 ? format(first,'dd/MM/yy HH:mm') : false;
                        last = last > 0 ? format(last,'dd/MM/yy HH:mm') : false;
                        if ( !first ) return '';
                        if ( rr.length == 0 ) return first;
                        return first + ' - ' + last
                    } },
                ],
                filter: {},
                project: { client_id: 1 },
                onItems ( items ) {
                    console.log('onItems',JSON.parse(JSON.stringify(items)));
                    items.forEach(item => {
                        item.customers = [];
                        WebSoc.SEND('search',{ DB: this.db, find: { 'ads.ad_id': item._id } , project: { _id: 1 } },customers => {
                            item.customers = customers;
                        });
                        item.campaigns = [];
                        WebSoc.SEND('search',{ DB: 'surveys', find: { 'pages.ad_id': item._id, currentOffers: { $ne: true } }, project: { _id: 1 } },campaigns => {
                            item.campaigns = campaigns;
                        })
                    })
                    
                } 
            } 
        }
    },
    methods: {
        'ad-list' ({ field, item, value, e }) {
            
            switch ( field.field ) {
                case 'title':
                    return this.showVoucher(item);
                case 'qtySent':
                case 'rotate':
                case 'unique':
                case 'redeemCount':
                case 'dLinked':
                case 'dLink':
                case 'dRotate':    
                    return this.showStats(item);
                case 'customers':
                case 'campaigns':
                    return this.showCustomersCampaigns(item);         
            }

            console.log('ad-list',field.field);

        },
        'stats-ads' ({ item, action }) {
            switch ( action ) {
                case 'exit':
                    return this.ad = false;
            }
        },
        showCustomersCampaigns ( item ) {
            console.log('showCustomersCampaigns');
            this.item = item;
            this.component = 'statsCustomerCampaign';
            console.log('this.component',this.component);
        },
        showStats ( item ) {
            WebSoc.SEND('get',{ DB: 'jb-ads', _id: item._id },ad => {
                this.ad = ad;
            })
        },
        deleteAd ( voucher ) {
            console.log('deleteAd ??',JSON.parse(JSON.stringify(voucher)));
        },
        showVoucher ( ad ) {
            WebSoc.SEND('search',{ DB: 'surveys', find: { 'pages.ad_id': ad._id } },campaigns => {
                var campaign = campaigns[0];
                if ( !campaign ) return Alert.yesno('This Ad is in NO Campaigns - Do you want to delete it ?',yes => {
                    if ( !yes ) return;
                    WebSoc.SEND('delete',{ DB: 'jb-ads', _id: ad._id },() => {
                        console.log('deleted',ad);
                    })
                });
                var activity = campaigns.reduce((p,c) => { 
                    
                    var AD = c.pages.find(p => p.ad_id == ad._id); 
                    if ( !AD ) return p; 
                    AD.issued > 0 && ( p.issued += AD.issued ); 
                    AD.redeemed > 0 && ( p.redeemed += AD.redeemed ); 

                    return p;  },{ issued: 0, redeemed: 0 });
                    
                var Ad = campaign.pages.find(p => p.ad_id == ad._id);
                    Ad.issued = activity.issued;
                    Ad.redeemed = activity.redeemed;

                this.voucher = Ad;
            })
        },
        emit ( data ) {
            if ( data.action == 'exit' ) {
                this.component = '';
                this.item = false;
            }
            if ( typeof this[data.t] == 'function' ) return this[data.t](data);
        },
    }
}    
</script>